const SAFE_LENGTH = 26;

const safeStringLength = (value: string) => {
  let valueArray = value.split(' ');
  let newString = '';
  do {
    newString += ` ${valueArray.shift()}`;
  } while (newString.length < SAFE_LENGTH && valueArray.length);
  return newString.trimStart();
};

export default safeStringLength;
